<template>
  <v-page-content>
    <content-info-page></content-info-page>
  </v-page-content>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { types } from '@/config/content/types'

const ContentInfoPage = () => import('@/components/content/edit/EditContentInfo.vue')

export default {
  name: 'EditSelectedEvent',
  components: {
    ContentInfoPage
  },
  beforeRouteUpdate(to, from, next) {
    this.getData(to.params.id)
    next()
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    ...mapActions({
      fetchSelectedEvent: 'content/fetchSelectedContent'
    }),
    ...mapMutations({
      setContentType: 'content/setContentType'
    }),
    getData(id) {
      this.fetchSelectedEvent(id).then((data) => {
        if (data) {
          this.$router.push('/page_not_exist')
        } else {
          this.setContentType(types.event)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
